function PageNotFound() {

    return (
        <h1>NotFound</h1>
    )
}
export default PageNotFound